import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=917c7f36&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=917c7f36&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917c7f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('917c7f36')) {
      api.createRecord('917c7f36', component.options)
    } else {
      api.reload('917c7f36', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=917c7f36&scoped=true", function () {
      api.rerender('917c7f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/detail.vue"
export default component.exports